module.exports = __webpack_public_path__ + "img/DE02758.9fa3023b.svg";